import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import TodoListProfile from "./TodoListProfile";
import CandidateOfferCard from "./CandidateOffersCard";
import ProfileProgressionSkeleton from "../skeletons/collab/ProfileProgressionSkeleton";

const TabContainer = styled(Box)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "50px",
  borderTopRightRadius: "13px",
  borderTopLeftRadius: "13px",
  zIndex: 100,
  backgroundColor: "#f0f0f0",
  boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.1)", // Ombre sur la droite
});
const TabItem: any = styled(Box, {
  shouldForwardProp: (props) => props !== "active",
})(({ active }: any) => ({
  height: "100%",
  width: "100%",
  borderTopRightRadius: "13px",
  borderTopLeftRadius: "13px",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  cursor: "pointer",
  backgroundColor: active ? "#ffffff" : "#f0f0f0",
  color: "auto",
}));

const BenefCardTodoInfo = ({
  person,
  context,
  owner,
  offerModal,
  isLoading,
  tab,
  setTab,
  setOpenAddTodoModal,
  setOwnerModal,
  setTodoDetail,
  setOpenDetailModal,
  progress,
}: any) => {
  const { t } = useTranslation("common");

  return (
    <div>
      <TabContainer>
        <TabItem active={tab === 0} onClick={() => setTab?.(0)}>
          <Typography variant="body2" textAlign="center">
            {t("todo.inf_download")}
          </Typography>
        </TabItem>
        <TabItem active={tab === 1} onClick={() => setTab?.(1)}>
          <Typography variant="body2" textAlign="center">
            {t("todo.title_list")}
          </Typography>
        </TabItem>
      </TabContainer>
      {tab === 0 ? (
        //! A voir si on verifie le parametre jobs pour afficher les offres:
        //  menu.jobs &&
        isLoading ? (
          <ProfileProgressionSkeleton withZoom={true} />
        ) : (
          <CandidateOfferCard
            person={person}
            context={context}
            offerModal={offerModal}
            sx={{
              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.1)",
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            }}
          />
        )
      ) : tab === 1 ? (
        <TodoListProfile
          person={person}
          context={context}
          owner={owner}
          sx={{
            boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.1)",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
          progress={progress}
          setOpenAddTodoModal={setOpenAddTodoModal}
          setOwnerModal={setOwnerModal}
          setOpenDetailModal={setOpenDetailModal}
          setTodoDetail={setTodoDetail}
        />
      ) : null}
    </div>
  );
};

export default BenefCardTodoInfo;
